<script setup>
import { ArrowRight, ArrowUpRight, Building2, Smartphone, Check } from 'lucide-vue-next'
import handoff from '../../assets/img/delivery-handoff-nic.webp'

const bullets = ['Repartidores verificados', 'Soporte humano']
</script>

<template>
  <section id="unete" class="relative scroll-mt-24 overflow-hidden bg-[#0a1120] py-24 text-white md:py-32">
    <!-- Fotografía real del servicio -->
    <img
      :src="handoff"
      alt="Repartidor de LLEVO entregando un paquete a una clienta en Managua"
      class="absolute inset-0 h-full w-full object-cover object-center opacity-65"
      loading="lazy"
      decoding="async"
    >
    <div class="absolute inset-0 bg-[linear-gradient(90deg,#0a1120_0%,rgba(10,17,32,0.95)_36%,rgba(10,17,32,0.55)_68%,rgba(10,17,32,0.12)_100%)]"></div>
    <div class="absolute inset-0 bg-gradient-to-t from-[#0a1120] via-transparent to-[#0a1120]/25"></div>

    <div class="container relative z-10 mx-auto px-6 lg:px-12">
      <div v-reveal class="max-w-3xl">
        <p class="text-[11px] font-black uppercase tracking-[0.18em] text-[#ff8a4c]">Únete a la red LLEVO</p>

        <h2 class="mt-5 text-balance text-3xl font-black leading-[1.08] tracking-[-0.03em] sm:text-4xl md:text-5xl lg:text-[3.4rem]">
          Tu negocio y tus clientes,
          <span class="text-transparent bg-clip-text bg-gradient-to-r from-[#ff8a4c] via-[#f0611e] to-[#ffb38a]">
            siempre en movimiento.
          </span>
        </h2>

        <p class="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
          Únete como comercio y despacha con nuestra red, o descarga la app y pide tu primer envío.
          Operamos con tecnología propia y repartidores locales para que cada entrega llegue segura y a tiempo.
        </p>

        <div class="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
          <router-link
            to="/postular-negocio"
            class="group inline-flex items-center justify-center gap-2.5 rounded-xl bg-[#c2410c] px-6 py-3.5 text-base font-bold text-white shadow-orange-glow transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#9a3412]"
          >
            <Building2 :size="18" />
            Registrar mi negocio
            <ArrowUpRight :size="17" class="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </router-link>
          <a
            href="#app-usuarios"
            class="group inline-flex items-center justify-center gap-2.5 rounded-xl border border-white/20 bg-[#0a1120]/40 px-6 py-3.5 text-base font-bold text-white backdrop-blur transition-all duration-200 hover:-translate-y-0.5 hover:border-white/35 hover:bg-white/10"
          >
            <Smartphone :size="18" />
            Descargar la app
            <ArrowRight :size="17" class="text-[#ff8a4c] transition-transform group-hover:translate-x-1" />
          </a>
        </div>

        <div class="mt-7 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs font-medium text-slate-400">
          <span v-for="bullet in bullets" :key="bullet" class="inline-flex items-center gap-1.5">
            <Check :size="14" class="text-[#ff8a4c]" />
            {{ bullet }}
          </span>
        </div>

        <router-link
          to="/postular-repartidor"
          class="group mt-5 inline-flex items-center gap-2 text-sm font-bold text-[#ff8a4c] transition-colors hover:text-white"
        >
          ¿Tienes moto, carro o camioneta? Únete como repartidor
          <ArrowUpRight :size="16" class="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </router-link>
      </div>
    </div>
  </section>
</template>
